export const environment = {
    production: false,
    apiUrl: 'https://api-staging.bloomiethebrand.com/api'
};
